import { useCallback } from 'react';

import { useCreateLogItemMutation } from '@/state/slices/logItem.ts';
import { ActionType, ObjectType } from '@/models/logItem';

type LogContext = Record<string, unknown>;

export interface LogEvent {
  actionType: ActionType;
  objectType?: ObjectType | null;
  objectId?: string | null;
  context?: LogContext | null;
}

export const useLogItem = () => {
  const [createLogItem] = useCreateLogItemMutation();

  const log = useCallback(
    (event: LogEvent) => {
      // fire-and-forget (don't block UI; ignore failures)
      createLogItem({
        actionType: event.actionType,
        objectType: event.objectType ?? null,
        objectId: event.objectId ?? null,
        context: event.context ?? null,
      }).catch(() => {});
    },
    [createLogItem]
  );

  return { log };
};
